import fp from 'lodash/fp';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  EXTERNAL_CPD: {
    GET: (externalCpdId) => ({ externalCpdId }),
    API: {
      GET: apiResourceActionCreator('externalCpd')
    }
  }
})

export const apiAction = (authToken, externalCpdId, payload) => commonApiActions.authenticated.get(`${API_ENDPOINT}/${externalCpdId}`, authToken, action.externalCpd.api.get)

function* getExternalCpd({ payload }) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, payload.externalCpdId, payload));
}

const configuration = {
  name: 'get',
  action: action,
  sagas: getExternalCpd,
  reducers: {
    request: fp.flow(
      fp.set('request.get.isFetching')(true),
      fp.set('externalCpd')(undefined),
      fp.set('error')(null)
    ),
    success: (state, action) => fp.flow(
      fp.set('request.get.isFetching')(false),
      fp.set('externalCpd')(action.payload.externalCpd)
    )(state),
    failed: (state, action) => fp.flow(
      fp.set('request.get.isFetching')(false),
      fp.set('request.get.error')(action.payload.error),
      fp.set('error')(action.payload.error)
    )(state)
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/external-cpd/configurations/get.js